/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  APIResponseBase,
  GetAttributes200Response,
  GetAttributesBucketName200Response,
} from '../models';
import {
    APIResponseBaseFromJSON,
    APIResponseBaseToJSON,
    GetAttributes200ResponseFromJSON,
    GetAttributes200ResponseToJSON,
    GetAttributesBucketName200ResponseFromJSON,
    GetAttributesBucketName200ResponseToJSON,
} from '../models';

export interface DeleteAttributesBucketNameRequest {
    bucketName: string;
    slashIDSdkVersion?: string;
    attributes?: Array<string>;
}

export interface GetAttributesRequest {
    slashIDSdkVersion?: string;
    buckets?: Array<string>;
}

export interface GetAttributesBucketNameRequest {
    bucketName: string;
    slashIDSdkVersion?: string;
    attributes?: Array<string>;
}

export interface PatchAttributesRequest {
    body: { [key: string]: { [key: string]: any; }; };
    slashIDSdkVersion?: string;
}

export interface PatchAttributesBucketNameRequest {
    bucketName: string;
    body: { [key: string]: any; };
    slashIDSdkVersion?: string;
}

export interface PutAttributesRequest {
    body: { [key: string]: { [key: string]: any; }; };
    slashIDSdkVersion?: string;
}

export interface PutAttributesBucketNameRequest {
    bucketName: string;
    body: { [key: string]: any; };
    slashIDSdkVersion?: string;
}

/**
 * 
 */
export class AttributesApi extends runtime.BaseAPI {

    /**
     * Delete attributes from a single bucket
     */
    async deleteAttributesBucketNameRaw(requestParameters: DeleteAttributesBucketNameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIResponseBase>> {
        if (requestParameters.bucketName === null || requestParameters.bucketName === undefined) {
            throw new runtime.RequiredError('bucketName','Required parameter requestParameters.bucketName was null or undefined when calling deleteAttributesBucketName.');
        }

        const queryParameters: any = {};

        if (requestParameters.attributes) {
            queryParameters['attributes'] = requestParameters.attributes.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.slashIDSdkVersion !== undefined && requestParameters.slashIDSdkVersion !== null) {
            headerParameters['SlashID-SdkVersion'] = String(requestParameters.slashIDSdkVersion);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/attributes/{bucket_name}`.replace(`{${"bucket_name"}}`, encodeURIComponent(String(requestParameters.bucketName))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIResponseBaseFromJSON(jsonValue));
    }

    /**
     * Delete attributes from a single bucket
     */
    async deleteAttributesBucketName(requestParameters: DeleteAttributesBucketNameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIResponseBase> {
        const response = await this.deleteAttributesBucketNameRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve attributes from multiple buckets
     */
    async getAttributesRaw(requestParameters: GetAttributesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAttributes200Response>> {
        const queryParameters: any = {};

        if (requestParameters.buckets) {
            queryParameters['buckets'] = requestParameters.buckets.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.slashIDSdkVersion !== undefined && requestParameters.slashIDSdkVersion !== null) {
            headerParameters['SlashID-SdkVersion'] = String(requestParameters.slashIDSdkVersion);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/attributes`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAttributes200ResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve attributes from multiple buckets
     */
    async getAttributes(requestParameters: GetAttributesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAttributes200Response> {
        const response = await this.getAttributesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve attributes from a single bucket
     */
    async getAttributesBucketNameRaw(requestParameters: GetAttributesBucketNameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAttributesBucketName200Response>> {
        if (requestParameters.bucketName === null || requestParameters.bucketName === undefined) {
            throw new runtime.RequiredError('bucketName','Required parameter requestParameters.bucketName was null or undefined when calling getAttributesBucketName.');
        }

        const queryParameters: any = {};

        if (requestParameters.attributes) {
            queryParameters['attributes'] = requestParameters.attributes.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.slashIDSdkVersion !== undefined && requestParameters.slashIDSdkVersion !== null) {
            headerParameters['SlashID-SdkVersion'] = String(requestParameters.slashIDSdkVersion);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/attributes/{bucket_name}`.replace(`{${"bucket_name"}}`, encodeURIComponent(String(requestParameters.bucketName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAttributesBucketName200ResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve attributes from a single bucket
     */
    async getAttributesBucketName(requestParameters: GetAttributesBucketNameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAttributesBucketName200Response> {
        const response = await this.getAttributesBucketNameRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create new attributes or modify existing attributes for a person in one or more attribute buckets.  Any existing attribute that isn\'t referenced by key in the request is left untouched. 
     * Create or modify attributes in multiple buckets
     */
    async patchAttributesRaw(requestParameters: PatchAttributesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIResponseBase>> {
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body','Required parameter requestParameters.body was null or undefined when calling patchAttributes.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.slashIDSdkVersion !== undefined && requestParameters.slashIDSdkVersion !== null) {
            headerParameters['SlashID-SdkVersion'] = String(requestParameters.slashIDSdkVersion);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/attributes`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIResponseBaseFromJSON(jsonValue));
    }

    /**
     * Create new attributes or modify existing attributes for a person in one or more attribute buckets.  Any existing attribute that isn\'t referenced by key in the request is left untouched. 
     * Create or modify attributes in multiple buckets
     */
    async patchAttributes(requestParameters: PatchAttributesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIResponseBase> {
        const response = await this.patchAttributesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create new attributes or modify existing attributes for a person in a single bucket.  Any existing attribute that isn\'t referenced by key in the request is left untouched. 
     * Create or modify attributes in a single bucket
     */
    async patchAttributesBucketNameRaw(requestParameters: PatchAttributesBucketNameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIResponseBase>> {
        if (requestParameters.bucketName === null || requestParameters.bucketName === undefined) {
            throw new runtime.RequiredError('bucketName','Required parameter requestParameters.bucketName was null or undefined when calling patchAttributesBucketName.');
        }

        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body','Required parameter requestParameters.body was null or undefined when calling patchAttributesBucketName.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.slashIDSdkVersion !== undefined && requestParameters.slashIDSdkVersion !== null) {
            headerParameters['SlashID-SdkVersion'] = String(requestParameters.slashIDSdkVersion);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/attributes/{bucket_name}`.replace(`{${"bucket_name"}}`, encodeURIComponent(String(requestParameters.bucketName))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIResponseBaseFromJSON(jsonValue));
    }

    /**
     * Create new attributes or modify existing attributes for a person in a single bucket.  Any existing attribute that isn\'t referenced by key in the request is left untouched. 
     * Create or modify attributes in a single bucket
     */
    async patchAttributesBucketName(requestParameters: PatchAttributesBucketNameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIResponseBase> {
        const response = await this.patchAttributesBucketNameRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create new attributes or modify existing attributes for a person in one or more attribute buckets.  Replaces the set of existing attributes with those present in the request. In other words, it deletes any existing attributes that aren\'t referenced by key in the request. 
     * Create or modify attributes in multiple buckets
     */
    async putAttributesRaw(requestParameters: PutAttributesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIResponseBase>> {
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body','Required parameter requestParameters.body was null or undefined when calling putAttributes.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.slashIDSdkVersion !== undefined && requestParameters.slashIDSdkVersion !== null) {
            headerParameters['SlashID-SdkVersion'] = String(requestParameters.slashIDSdkVersion);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/attributes`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIResponseBaseFromJSON(jsonValue));
    }

    /**
     * Create new attributes or modify existing attributes for a person in one or more attribute buckets.  Replaces the set of existing attributes with those present in the request. In other words, it deletes any existing attributes that aren\'t referenced by key in the request. 
     * Create or modify attributes in multiple buckets
     */
    async putAttributes(requestParameters: PutAttributesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIResponseBase> {
        const response = await this.putAttributesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create new attributes or modify existing attributes for a person in a single bucket.  Replaces the set of existing attributes with those present in the request. In other words, it deletes any existing attributes that aren\'t referenced by key in the request. 
     * Create or modify attributes in a single bucket
     */
    async putAttributesBucketNameRaw(requestParameters: PutAttributesBucketNameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIResponseBase>> {
        if (requestParameters.bucketName === null || requestParameters.bucketName === undefined) {
            throw new runtime.RequiredError('bucketName','Required parameter requestParameters.bucketName was null or undefined when calling putAttributesBucketName.');
        }

        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body','Required parameter requestParameters.body was null or undefined when calling putAttributesBucketName.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.slashIDSdkVersion !== undefined && requestParameters.slashIDSdkVersion !== null) {
            headerParameters['SlashID-SdkVersion'] = String(requestParameters.slashIDSdkVersion);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/attributes/{bucket_name}`.replace(`{${"bucket_name"}}`, encodeURIComponent(String(requestParameters.bucketName))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIResponseBaseFromJSON(jsonValue));
    }

    /**
     * Create new attributes or modify existing attributes for a person in a single bucket.  Replaces the set of existing attributes with those present in the request. In other words, it deletes any existing attributes that aren\'t referenced by key in the request. 
     * Create or modify attributes in a single bucket
     */
    async putAttributesBucketName(requestParameters: PutAttributesBucketNameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIResponseBase> {
        const response = await this.putAttributesBucketNameRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
